<template>
  <ul class="inquiries__tips">
    <li class="inquiries__tips-item">
      <div class="inquiries__tips-icon">
        <img src="@/assets/shared/img/common/icon-checkbook.svg" alt="" width="32" height="32" />
      </div>
      <h4 class="inquiries__tips-title">フォームに必要事項をご入力ください。</h4>
      <p class="inquiries__tips-text">以下の項目の一部は、NTT東日本ビジネスIDに登録いただいているお客さま情報を表示しています。ログアウトは<a @click.prevent="logout" class="inquiries__tips-link">こちら</a></p>
    </li>
  </ul>
</template>


<script>
export default {
  name: 'SignupAfter',
  methods: {
    logout() {
      // ブラウザリロード時の処理を破棄
      window.removeEventListener('beforeunload', this.isReloadCookieSet);

      // ログインフラグをfalseに設定
      this.$cookies.set('isLogin', 'false');
      sessionStorage.setItem('isLogin', 'false');

      let query = new URLSearchParams(this.$route.query);
      this.$cookies.set('query', query.toString());

      // ログアウトURLを生成
      let logoutUrl =
      process.env.VUE_APP_BARISTA_LOGIN_URL + 'auth/realms/nttidpf_user/protocol/openid-connect/logout' +
      '?id_token_hint=' + this.$store.state.userinfo.id_token +
      '&state=' + this.$cookies.get('state') +
      '&post_logout_redirect_uri=' + process.env.VUE_APP_HOST_URL + 'callback?' + query

      // ログアウトURLへ遷移
      window.location.href = logoutUrl
    },
    isReloadCookieSet() {
      this.$cookies.set('isReload', 'true')
    },
  },
  mounted() {
    // ブラウザリロード時の処理を設定
    window.addEventListener('beforeunload', this.isReloadCookieSet);
  },
  destroyed() {
    // ブラウザリロード時の処理を破棄
    window.removeEventListener('beforeunload', this.isReloadCookieSet);
  },
};
</script>
<style lang="scss" scoped>
.inquiries__tips-text {
  .inquiries__tips-link {
    color: #0078d4;
    text-decoration: none;
    cursor: pointer;
    &:hover {
      color: #0171c5;
      text-decoration: underline;
    }

    &:visited {
      color: #6846ce;
    }

    &:active {
      color: #ff5500;
    }
  }
}
</style>
